module.exports = __webpack_public_path__ + "img/ios_download.2928664f.svg";